import { ChangeDetectorRef, Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ArrayHelpers, TranslateFormatText } from '../../helpers/array.helpers';
import { StandardRequestBase } from '../../services/request-base';
import { RolesService } from '../../services/roles.service';
import { UsersService } from '../../services/users.service';
import { DataCheck } from '../../workflow/workflow.dialog';
import { BaseListDetail, BaseListSettings, DeleteTexts, SaveTexts } from '../base.list.settings';
import { APIKeyService } from '../../services/apikeys.service';

@Component({
    selector: 'apikeys-settings',
    templateUrl: '../base.list.settings.html'
})
export class ApiKeysSettings extends BaseListSettings {

    constructor(private translate: TranslateService, private standardService: StandardRequestBase, protected cdRef: ChangeDetectorRef) {
        super(cdRef);
    }

    getContentType() {
        return ApiKeysDetail;
    }

    loadList(handler) {
        this.standardService.executeGet('api/settings/apikeys', 'getapikeys').subscribe(result => {
            if (result) {
                var list = [];
                result.forEach(function (entry) {
                    list.push({
                        Caption: entry.Caption,
                        ID: entry.SID
                    });
                });
                handler(list);
            }
        });
    }

    loadData(data) {
        this.standardService.executeGet('api/settings/apikeys', 'getapikey', 'sid=' + data).subscribe(result => {
            if (result) {
                this.setSelectedItem(result);
            }
        });
    }

    getNewItem() {
        return {
            Name: this.translate.instant('@@Neuer API-Key'),
        };
    }

    getDeleteText(sel): DeleteTexts {
        const retVal = new DeleteTexts();
        retVal.Question = new TranslateFormatText('@@Sind Sie sicher, dass Sie den API-Key \'{0}\' loeschen moechten?');
        retVal.Question.FormatParams.push(sel.Caption);
        retVal.Success = new TranslateFormatText('@@API-Key \'{0}\' erfolgreich geloescht.');
        retVal.Success.FormatParams.push(sel.Caption);
        retVal.Title = new TranslateFormatText('@@API-Key loeschen');
        return retVal;
    }

    getSaveSuccessText(sel): SaveTexts {
        //const retVal = new TranslateFormatText('@@Gruppe \'{0}\' erfolgreich gespeichert.');
        //retVal.FormatParams.push(sel.Name);
        //return retVal;
        const retVal = new SaveTexts();
        retVal.Text = new TranslateFormatText('@@API-Key \'{0}\' erfolgreich gespeichert.');
        retVal.Text.FormatParams.push(sel.Caption);
        retVal.Title = new TranslateFormatText('@@API-Key speichern');
        return retVal;
    }


    delete(data, handler) {
        this.standardService.executeDelete('api/settings/apikeys', 'deleteapikey', 'sid=' + data).subscribe((res) => {
            handler(res);
        });
    }

    saveInternal(item, handler) {
        this.standardService.executePost(item, 'api/settings/apikeys', 'SaveApiKey').subscribe(result => {
            if (result) {
                handler(result, result, item.Name);
            }
        });
    }

    handleNew(item, result) {
        item.SID = result;
    }

    protected async checkCanSave(): Promise<DataCheck> {
        var retVal = new DataCheck();
        var sel = this.Component.SelectedItem;
        if (sel) {
            if (typeof sel.Name !== 'string' || sel.Name == '') {
                retVal.IsCorrect = false;
                retVal.Error = this.translate.instant('@@Fehlender Name');
            }
        }
        return retVal;
    }

    static GetSettingsEntry() {
        return {
            Caption: '@@APIKeys',
            ID: 'apikeys',
            Icon: 'CustomRest',
            Index: 5,
            Parent: 'userCont',
            Security: {
                Name: 'evidanza.App.Shared.Security.UsermanagementRight',
                Value: 4
            },
            Content: ApiKeysSettings
        }
    }
}

@Component({
    selector: 'apikeys-detail',
    templateUrl: './apikeys.settings.html',
    styleUrls: ['./apikeys.settings.css']
})
export class ApiKeysDetail extends BaseListDetail {

    constructor(private userService: UsersService, private apikeyService: APIKeyService) {
        super();
    }

    ngOnInit(): void {
        this.userService.ReadUserInfos().subscribe(result => {
            if (result) {
                ArrayHelpers.sortAlphabetical(result, 'Name');
                this.Users = result;
            }
        });
    }

    //#region Users
    Users = [];


    //#endregion

    OnUserChanged() {

    }

    createNewKey() {
        this.apikeyService.CreateNewApiKey().subscribe(result => {
            if (result) {
                this.SelectedItem.APIKeyValue = result;
                this.OnItemChanged();
            }
        });
    }
}